import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '@/store/useAuthStore';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated, loading, isVerifyingAuth, verifyAuth } = useAuthStore();
    const location = useLocation();

    // Lazily verify auth when this guard mounts
    useEffect(() => {
        verifyAuth();
    }, [verifyAuth]);

    // Show loading spinner while checking authentication
    if (loading || isVerifyingAuth) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-zinc-900">
                <div className="text-center">
                    <Loader2 className="w-12 h-12 text-[rgb(var(--accent-1))] animate-spin mx-auto" />
                    <p className="mt-4 text-zinc-400">Loading...</p>
                </div>
            </div>
        );
    }

    // If not authenticated, redirect to login with return URL
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    // User is authenticated, render the protected content
    return <>{children}</>;
} 